/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import Swiper from 'swiper/bundle';

$(document).ready(() => {
    const SwiperHomepage = new Swiper('.swiper--homepage', {
        direction: 'horizontal',
        autoHeight: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        loop: false,
    });
});
